// v2 campaign catalog lane — owned by the same agent as app/v2/slot6.tsx. Do not edit
// from another lane. One entry per shipped v2 page.
import type { V2CatalogEntry } from './types';

export const slot6Catalog: V2CatalogEntry[] = [
  {
    rank: 21,
    title: 'Event Log',
    route: '/system/event-log2',
    faithfulRoute: '/browse/event-log',
    score: 18,
    blurb:
      'Errored / reprocessable / blocked with the oldest-unresolved age, the record beside the list instead of behind Switch View, and the buffered resubmit shown as a staged batch you can Save.',
  },
  {
    rank: 22,
    title: 'System Locks',
    route: '/manage/system-locks2',
    faithfulRoute: '/manage/system-locks',
    score: 18,
    blurb:
      'The lock AGE that eight PB tabs never subtract, a rail grouped by what is blocked rather than by lock table, and one arm that releases every stale lock in a view.',
  },
  {
    rank: 47,
    title: 'Alarms',
    route: '/inquiry/alarms2',
    faithfulRoute: '/inquiry/alarms',
    score: 16,
    blurb:
      'Open vs closed by age with the automatic/manual split PB sorts on, the untouched-alarm count, and the more_info_* pointers turned into a named Investigate action beside the resolution.',
  },
  {
    rank: 39,
    title: 'Location Status',
    route: '/location/status2',
    faithfulRoute: '/location/status',
    score: 17,
    blurb:
      'Occupancy, mix and holds folded out of the Items tab alone — with a real % of capacity meter, a mixed-item and held-pieces verdict, and Adjust Inventory promoted to the items row instead of "whichever tab is showing".',
  },
  {
    rank: 49,
    title: 'Location Maintenance',
    route: '/location/maintenance2',
    faithfulRoute: '/location/maintenance',
    score: 16,
    blurb:
      'A "can I use this location" band above the 67 fields — blocked / occupied / pending work / % full as words rather than greyed checkboxes — with the contents beside the rules and a status column on the search results. Read-first: editing stays on the PB page.',
  },
  {
    rank: 50,
    title: 'Label Center',
    route: '/labels/central2',
    faithfulRoute: '/labels/central',
    score: 16,
    blurb:
      'Pick the job ("Label a receipt line"), not the opaque action code — same action-meta cascade underneath — with the print log and printers folded in beside the form and the station remembered per user.',
  },
];
